
export const REQUEST_LOAD_PERSONAL_WORKOUTS = 'events/REQUEST_LOAD_PERSONAL_WORKOUTS';
